import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { OpkraevningsListerSearchComponent } from './opkraevningslister-search/opkraevningslister-search.component';
import { OpkraevningsListerResultComponent } from './opkraevningslister-result/opkraevningslister-result.component';
import { OpkraevningsListerDetailComponent } from './opkraevningslister-detail/opkraevningslister-detail.component';
import { OpkraevningsListerService } from './opkraevningslister.service';
import { OpkraevningService } from '@features/opkraevning/opkraevning.service';
import { OpkraevningDetailComponent } from '@features/opkraevning/opkraevning-detail/opkraevning-detail.component';

@Component({
  selector: 'app-opkraevningslister',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    OpkraevningsListerSearchComponent,
    OpkraevningsListerResultComponent,
    OpkraevningsListerDetailComponent,
    OpkraevningDetailComponent,
  ],
  templateUrl: './opkraevningslister.component.html',
  styleUrl: './opkraevningslister.component.css',
})
export class OpkraevningsListerComponent {
  opkraevningsListerService = inject(OpkraevningsListerService);
  opkraevningService = inject(OpkraevningService);
  data = this.opkraevningsListerService.datasource.data;

}
